module.exports = __webpack_public_path__ + "img/turn-up.6049a593.svg";